import { useApi } from '@/composables/useApi'

const api = useApi()

// eslint-disable-next-line import/prefer-default-export
export const sendNfeBling = pedidoId => new Promise((resolve, reject) => api.post(`/pedidos/${pedidoId}/sendNfe`)
  .then(res => {
    resolve(res.data)
  })
  .catch(err => {
    reject(err)
  }))

export const sendMassNfeBling = pedidosIds => new Promise((resolve, reject) => api.post('/pedidos/massSendNfe', { pedidos_ids: pedidosIds })
  .then(res => {
    resolve(res.data)
  })
  .catch(err => {
    reject(err)
  }))

export const resendMailPix = pedidoId => new Promise((resolve, reject) => api.post(`/pedidos/${pedidoId}/resendMailPix`)
  .then(res => {
    resolve(res.data)
  })
  .catch(err => {
    reject(err)
  }))
